import { render, staticRenderFns } from "./center_16.vue?vue&type=template&id=64fdd926&scoped=true&"
import script from "./center_16.vue?vue&type=script&lang=js&"
export * from "./center_16.vue?vue&type=script&lang=js&"
import style0 from "./center_16.vue?vue&type=style&index=0&id=64fdd926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fdd926",
  null
  
)

export default component.exports